import { between, down, not, only, up } from 'app/helpers/breakpoints';
import { Theme } from 'app/theme/theme';

const xs = 0;
const sm = 600;
const md = 900;
const lg = 1200;
const xl = 1536;

const XS = 'xs';
const SM = 'sm';
const MD = 'md';
const LG = 'lg';
const XL = 'xl';

const BREAKPOINT_VALUES = {
  [XS]: xs,
  [SM]: sm,
  [MD]: md,
  [LG]: lg,
  [XL]: xl,
};

export const getBreakpoints = (theme: Theme) => ({
  values: BREAKPOINT_VALUES,
  between: between(BREAKPOINT_VALUES, theme),
  down: down(BREAKPOINT_VALUES, theme),
  not: not(BREAKPOINT_VALUES, theme),
  only: only(BREAKPOINT_VALUES, theme),
  up: up(BREAKPOINT_VALUES, theme),
});
